module.exports = __webpack_public_path__ + "img/001.201829c1.jpg";